import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./index.css";
import "./index2.css";
import { Provider } from "react-redux";
import { ThemeProvider } from "@mui/material";
//import { createReduxStore } from "./Components/Redux/Store";
import store from "./Components/Redux/Store";
// import { ReactKeycloakProvider } from '@react-keycloak/web'
// import "ag-grid-community/styles/ag-grid.css";
// import "ag-grid-community/styles/ag-theme-alpine.css";
import { MainTheme } from "./Themes/MainTheme";



const id = document.getElementById("root").dataset.id;
const tk = document.getElementById("root").dataset.tk;
const layout = document.getElementById("root").dataset.layout;
const debug = document.getElementById("root").dataset.debug;
const tenantCode = document.getElementById("root").dataset.tenantcode;

if (debug !== "true") {
  console.log("Debud is : ", debug);
  console.log = () => {};
  console.error = () => {};
  console.warn = () => {};
}
console.log("From Index: ", tenantCode);

ReactDOM.render(
  //   <ReactKeycloakProvider authClient={keycloak} >
  <ThemeProvider theme={MainTheme}>
    <Provider store={store}>
      <App
        id={id}
        tk={tk}
        layout_id={layout}
        debug={debug === "true" ? false : true}
        tenantCode={tenantCode}
      />
    </Provider>
  </ThemeProvider>,
  // </ReactKeycloakProvider>
  document.getElementById("root")
);
